import { defaultResumeData, idSchema, resumeDataSchema } from "@stylingcv/schema";
import { dateSchema } from "@stylingcv/utils";
import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

import { userSchema } from "../user";

// Base resume schema without relations (to avoid circular reference)
const baseResumeSchema = z.object({
  id: idSchema,
  title: z.string(),
  slug: z.string(),
  data: resumeDataSchema.default(defaultResumeData),
  visibility: z.enum(["private", "public"]).default("private"),
  locked: z.boolean().default(false),
  type: z.enum(["resume", "coverLetter"]).default("resume"),
  sourceResumeId: z.string().nullable().optional(),
  thumbnail: z.string().nullable().optional(),
  userId: idSchema,
  user: userSchema.optional(),
  createdAt: dateSchema,
  updatedAt: dateSchema,
});

// Full resume schema with sourceResume relation
export const resumeSchema = baseResumeSchema.extend({
  sourceResume: baseResumeSchema.nullable().optional(),
});

export class ResumeDto extends createZodDto(resumeSchema) {}
